import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import typescript from '../assets/typescript.png';

import profile2 from '../assets/profile2.png';
import circle from '../assets/circle.svg';



const images = {
    email,
    mobile,
    api,
    cpp,
    css,
    figma,
    git,
    graphql,
    html,
    javascript,
    node,
    python,
    react,
    typescript,
    profile2,
    circle,
};

export default images;